import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function relatedDocumentsReducer(state = initialState.relatedDocuments, action) {
	switch (action.type) {
		case types.GET_RELATED_DOCUMENTS: {
            if (action?.response?.data) {
                const relatedDocumentIds = action.response.data.map((doc) => doc.id);
                return relatedDocumentIds;
            }
			return state;
		}
		case types.ASSOCIATE_TASK_DOCUMENTS: {
			const functionType = action?.payload?.functionType?.toUpperCase();
			const documentId = action?.meta?.api?.data?.DocumentId;
			const operationType = action?.meta?.api?.data?.operationType;
			if (functionType === 'RELATE' && documentId && operationType) {
				// operationType 1 indicates associate document and 2 represents unassociate document.
				const relatedDocumentIds = operationType == 1 ? [...state, documentId] : state.filter(id => id != documentId);
                return relatedDocumentIds;
			}
            return state;
		}
		case types.CLEAR_RELATED_DOCUMENTS:
			return [];
		default:
			return state;
	}
}